'use client';
import { useState, useEffect } from 'react';
import { TextMorph } from '@/components/motion-primitives/text-morph';

export function HeroTextMorph({ words, interval }: { words: string[]; interval: number }) {
  const [text, setText] = useState(words[0]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const currentIndex = words.indexOf(text);
      const nextIndex = (currentIndex + 1) % words.length;
      setText(words[nextIndex]);
    }, interval * 1000);
    return () => clearInterval(intervalId);
  }, [words, interval, text]);

  return (
    <TextMorph as="span" className="inline-block">
      {text}
    </TextMorph>
  );
}
